import * as THREE from 'three';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import { gsap } from 'gsap';

const root = document.documentElement;
const lightModeButton = document.getElementById('lightModeButton');
const soundToggleButton = document.getElementById('soundToggleButton');
const backButton = document.getElementById('backButton');
const aboutMeButton = document.getElementById('aboutMeButton');
const contactButton = document.getElementById('contactButton');
const aboutCloseButton = document.getElementById('aboutCloseButton');
const contactCloseButton = document.getElementById('contactCloseButton');
const emailLink = document.getElementById('emailLink');
const phoneLink = document.getElementById('phoneLink');
const detailContainers = {
  detail0: document.getElementById('detail0'),
  detail1: document.getElementById('detail1'),
  detail2: document.getElementById('detail2'),
  detail3: document.getElementById('detail3'),
  detail4: document.getElementById('detail4'),
  detail5: document.getElementById('detail5'),
  detail6: document.getElementById('detail6'),
  detail7: document.getElementById('detail7'),
  detail8: document.getElementById('detail8'),
  detail9: document.getElementById('detail9'),
};
const detailCloseButtons = document.querySelectorAll('.detailCloseButton');
const menuContainer = document.querySelector('.menu_container');
const aboutMeContainer = document.querySelector('.about_container');
const contactContainer = document.querySelector('.contact_container');
const cameraTurnButton = document.querySelector('.menu_button-camera');
const darknessContainer = document.querySelector('.darkness');
const tvHover = document.querySelector('.tv_hover');

const saved = localStorage.getItem('theme');

let generalSound = 0;

const renderer = new THREE.WebGLRenderer({ antialias: true });
renderer.outputColorSpace = THREE.SRGBColorSpace;

renderer.setSize(window.innerWidth, window.innerHeight);
renderer.setClearColor(0x000000);
renderer.setPixelRatio(window.devicePixelRatio);

renderer.shadowMap.enabled = true;
renderer.shadowMap.type = THREE.PCFSoftShadowMap;

document.body.appendChild(renderer.domElement);

const scene = new THREE.Scene();

const camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 0.1, 1000);
camera.position.set(0.4, 0.7, 1.2);
const cameraDirection = new THREE.Vector3(-0.265, 0.5, -0.3);
camera.lookAt(cameraDirection);

let lockCameraRotation = false;
let cameraTurned = false;
let inAboutSection = false;
let inContactSection = false;
let tvClicked = false;
let lockClicks = false;

const tvInfo = [
  { title: 'Scrollytelling', position: [1.75, 0, 1.245] },
  { title: `Bug's Life`, position: [1.665, 0, 1.6] },
  { title: `Plantin's story`, position: [1.479, 0, 1.91] },
  { title: 'Design cities', position: [1.69, 0.215, 1.045] },
  { title: 'Monster Energy 3D', position: [1.7075, 0.215, 1.4225] },
  { title: 'Pinball machine', position: [1.57, 0.215, 1.762] },
  { title: 'Forest generator', position: [1.32, 0.215, 2.03] },
  { title: 'Telenet conference', position: [1.74, 0.43, 1.185] },
  { title: 'LARQ bottle Ad', position: [1.645, 0.43, 1.65] },
  { title: 'Mixbox app & branding', position: [1.439, 0.43, 1.95] },
  { title: 'Contact', position: [1.57, 0.645, 1.832] },
];



let clickCount = 0;
let mouseX = 0;
let mouseY = 0;
let needX = -0.265;
let needY = 0.5;
let needZ = -0.3;
let directionZ = needZ;
let directionX = needX + mouseX * (-0.5);
let directionY = needY - mouseY * 0.2;
let isCampfireBurning = true;
let isBoomboxPlaying = false;

const leavesSound = new Audio('assets/sounds/leaves.mp3');
const fireStartSound = new Audio('assets/sounds/fire-start.mp3');
const fireEndSound = new Audio('assets/sounds/fire-end.mp3');
const fireSound = new Audio('assets/sounds/fire.mp3');
const groundSound = new Audio('assets/sounds/ground.mp3');
const wallSound = new Audio('assets/sounds/wall.mp3');
const woodSound = new Audio('assets/sounds/wood.mp3');
const paperSound = new Audio('assets/sounds/paper.mp3');
const music = new Audio('assets/sounds/music.mp3');
const cassetteSound = new Audio('assets/sounds/cassette.mp3');
const cassetteOutSound = new Audio('assets/sounds/cassette-out.mp3');
const ambient = new Audio('assets/sounds/ambient.mp3');
ambient.loop = true;
fireSound.loop = true;
music.loop = true;

const updateCameraRotation = () => {
  if (lockCameraRotation) return;
  if (!cameraTurned) {
    needX = -0.265;
    needY = 0.5;
    needZ = -0.3;
    directionZ = needZ;
    directionX = needX + mouseX * 0.2;
    directionY = needY - mouseY * 0.2;
  } else {
    needX = 1.665;
    needY = 0.4;
    needZ = 1.6;
    directionZ = needX + mouseX * 0.1;
    directionX = needX + mouseX * (-0.2);
    directionY = needY - mouseY * 0.1;
  }

  gsap.to(cameraDirection, {
    x: directionX,
    y: directionY,
    z: directionZ,
    duration: 1.2,
    ease: "power2.out",
    onUpdate: () => {
      camera.lookAt(cameraDirection);
    }
  });  
}

const changeLight = (next, isCameraTurned, duration, delay) => {
  lockClicks = true;
  if (next === 'dark') {
    document.getElementById('icon-light').style.display = 'none';
    document.getElementById('icon-dark').style.display = 'block';
    if (!isCameraTurned) {
      gsap.to(directionalLight.position, { x: -10, y: 2, z: 10, duration: duration, delay: delay });
      gsap.to(directionalLight.color, { r: 1, g: 0.627, b: 0.478, duration: duration, delay: delay });
      gsap.to(directionalLight, { intensity: 30, duration: duration / 2, delay: delay, onComplete: () => {
        gsap.to(directionalLight, { intensity: 40.8, duration: 0.35, onComplete: () => { lockClicks = false; } });
      }});

      gsap.to(ambientLight.color, { r: 1, g: 0.627, b: 0.478, duration: duration, delay: delay });
      gsap.to(ambientLight, { intensity: 0.2, duration: duration, delay: delay });
    } else {
      gsap.to(directionalLight.position, { x: 0.6, y: 0.5, z: 1.2, duration: duration, delay: delay });
      gsap.to(directionalLight.color, { r: 1, g: 0.627, b: 0.478, duration: duration, delay: delay });
      gsap.to(directionalLight, { intensity: 1, duration: duration, delay: delay, onComplete: () => { lockClicks = false; } });

      gsap.to(ambientLight.color, { r: 1, g: 0.894, b: 0.882, duration: duration, delay: delay });
      gsap.to(ambientLight, { intensity: 0.1, duration: duration, delay: delay });
    }
  } else {
    document.getElementById('icon-light').style.display = 'block';
    document.getElementById('icon-dark').style.display = 'none';
    if (!isCameraTurned) {
      gsap.to(directionalLight.position, { x: 10, y: 30, z: 20, duration: duration, delay: delay });
      gsap.to(directionalLight.color, { r: 1, g: 0.961, b: 0.882, duration: duration, delay: delay });
      gsap.to(directionalLight, { intensity: 2020.5, duration: duration, delay: delay, onComplete: () => { lockClicks = false; } });

      gsap.to(ambientLight.color, { r: 1, g: 1, b: 1, duration: duration, delay: delay });
      gsap.to(ambientLight, { intensity: 0.2, duration: duration, delay: delay });
    } else {
      gsap.to(directionalLight.position, { x: 0.6, y: 2, z: 1.2, duration: duration, delay: delay });
      gsap.to(directionalLight.color, { r: 1, g: 1, b: 1, duration: duration, delay: delay });
      gsap.to(directionalLight, { intensity: 5.5, duration: duration, delay: delay, onComplete: () => { lockClicks = false; } });

      gsap.to(ambientLight.color, { r: 1, g: 1, b: 1, duration: duration, delay: delay });
      gsap.to(ambientLight, { intensity: 0.4, duration: duration, delay: delay });
    }
  }
};

const updateInterface = () => {
  if (cameraTurned || inAboutSection || inContactSection) {
    gsap.to(menuContainer, {
      opacity: 0,
      transform: 'translate(-50%, -35%)',
      duration: 0.65,
      ease: "power2.out",
      onComplete: () => {
        menuContainer.style.display = 'none';
      }
    });
  } else {
    gsap.to(menuContainer, {
      opacity: 1,
      transform: 'translate(-50%, -50%)',
      duration: 0.65,
      delay: 0.375,
      ease: "power2.out",
      onStart: () => {
      menuContainer.style.display = 'block';
      }
    });
  }
  if (tvClicked || cameraTurned) {
    gsap.to(backButton, {
      opacity: 1,
      duration: 0.65,
      ease: "power2.out",
      delay: 0.65,
      onStart: () => {
      backButton.style.display = 'flex';
      }
    });
  }
  else {
    gsap.to(backButton, {
      opacity: 0,
      duration: 0.65,
      ease: "power2.out",
      delay: 0.65,
      onComplete: () => {
        backButton.style.display = 'none';
      }
    });
  }
  if (tvClicked) {
    lightModeButton.style.display = 'none';
    soundToggleButton.style.display = 'none';
  }
  else {
    lightModeButton.style.display = 'flex';
    soundToggleButton.style.display = 'flex';
  }
  if (inAboutSection) {
    gsap.to(aboutMeContainer, {
      opacity: 1,
      transform: 'translate(-50%, -50%)',
      duration: 0.65,
      ease: "power2.out",
      onStart: () => {
      aboutMeContainer.style.display = 'flex';
      }
    });
  }
  else {
    gsap.to(aboutMeContainer, {
      opacity: 0,
      transform: 'translate(-50%, -35%)',
      duration: 0.65,
      ease: "power2.out",
      onComplete: () => {
        aboutMeContainer.style.display = 'none';
      }
    });
  }

  if (inContactSection) {
    gsap.to(contactContainer, {
      opacity: 1,
      transform: 'translate(-50%, -50%)',
      duration: 0.65,
      ease: "power2.out",
      onStart: () => {
        contactContainer.style.display = 'flex';
      }
    });
  } else {
    gsap.to(contactContainer, {
      opacity: 0,
      transform: 'translate(-50%, -35%)',
      duration: 0.65,
      ease: "power2.out",
      onComplete: () => {
        contactContainer.style.display = 'none';
      }
    });
  }
  
  if (!tvClicked) {
    Object.values(detailContainers).forEach(container => {
      gsap.to(container, {
        opacity: 0,
        transform: 'translate(-50%, -35%)',
        duration: 0.65,
        ease: "power2.out",
        onComplete: () => {
          container.style.display = 'none';
        }
      });
    });
    Object.values(detailContainers).forEach(container => {
      const videos = container.querySelectorAll('* video');
      videos.forEach(video => {
      video.pause();
      });
    });
  }
  if (document.getElementById('second-progress-container').style.display != 'none') {
    if (cameraTurned) {
    gsap.to(document.getElementById('second-progress-container'), {
      opacity: 1,
      delay: 0.6,
      ease: "power2.out"
    });
  }
  }
  
}

fireSound.addEventListener('timeupdate', () => {
  const buffer = 0.14;
  if (fireSound.currentTime > fireSound.duration - buffer) {
    fireSound.currentTime = 0;
    fireSound.play();
  }
});

document.addEventListener('mousemove', (event) => {
  firePlaneMesh.lookAt(camera.position);
  mouseX = (event.clientX / window.innerWidth) * 2 - 1;
  mouseY = (event.clientY / window.innerHeight) * 2 - 1;
  mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
  mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

  if (cameraTurned && !tvClicked) {
    tvHover.style.left = `${event.clientX}px`;
    tvHover.style.top = `${event.clientY}px`;
  }
});

document.addEventListener('click', (event) => {
  clickCount++;
  
  if (clickCount === 1) {
    ambient.play();
    fireSound.play();
  }

  if (inAboutSection && !aboutMeContainer.contains(event.target)) {
    aboutCloseButton.click(); // Trigger the close button functionality
  }
  if (inContactSection && !contactContainer.contains(event.target)) {
    contactCloseButton.click(); // Trigger the close button functionality
  }
});

document.addEventListener('wheel', (event) => {
  fireFactor -= event.deltaY * 0.06;
  fireFactor = Math.round(fireFactor);
  fireFactor = THREE.MathUtils.clamp(fireFactor, 1, 10);
  gsap.to(fireShaderMaterial.uniforms.fireFactor, {
    value: fireFactor,
    duration: 0.5,
    ease: "power2.out",
    onUpdate: () => {
      fireFactor = fireShaderMaterial.uniforms.fireFactor.value;
      updateFirePlaneGeometry();
    }
  });
});

const groundGeometry = new THREE.PlaneGeometry(20, 20, 32, 32);
groundGeometry.rotateX(-Math.PI / 2);
const textureLoader = new THREE.TextureLoader();
const groundTexture = textureLoader.load('assets/asphalt.jpg');
groundTexture.wrapS = THREE.RepeatWrapping;
groundTexture.wrapT = THREE.RepeatWrapping;
groundTexture.repeat.set(10, 10);

const groundMaterial = new THREE.MeshStandardMaterial({
  color: 0x555555,
  map: groundTexture,
  side: THREE.DoubleSide
});

const groundMesh = new THREE.Mesh(groundGeometry, groundMaterial);
groundMesh.castShadow = false;
groundMesh.receiveShadow = true;
scene.add(groundMesh);

const currentTheme = saved ? saved : 'dark';
root.setAttribute('data-theme', currentTheme);

const directionalLight = new THREE.PointLight(0xFFFFFF, 1);
directionalLight.shadow.bias = -0.0001;
const ambientLight = new THREE.AmbientLight(0xFFFFFF, 1);

changeLight(currentTheme, cameraTurned, 0, 0);
updateInterface();

scene.add(directionalLight);
scene.add(ambientLight);

directionalLight.castShadow = true;

const raycaster = new THREE.Raycaster();
const mouse = new THREE.Vector2();

let boxMesh;
let campfireMesh;
let leavesMesh;
let otherLeavesMesh;
let palletMesh;
let wallMesh;
let posterMesh;
let cardboardMesh;
let cardboardMesh2;
let wallMesh2;

let tvMeshes = [];
let tvMesh0, tvMesh1, tvMesh2, tvMesh3, tvMesh4, tvMesh5, tvMesh6, tvMesh7, tvMesh8, tvMesh9, tvMesh10;



const firstLoadingManager = new THREE.LoadingManager();
const secondLoadingManager = new THREE.LoadingManager();

firstLoadingManager.onProgress = (url, itemsLoaded, itemsTotal) => {
  const progress = (itemsLoaded / itemsTotal) * 100;
  const percentageElement = document.getElementById('percentage');
  if (percentageElement) {
    percentageElement.innerText = `${Math.round(progress)}%`;
  }
};

secondLoadingManager.onProgress = (url, itemsLoaded, itemsTotal) => {
  const progress = (itemsLoaded / itemsTotal) * 100;
  const secondProgressElement = document.getElementById('second-percentage');
  if (secondProgressElement) {
    secondProgressElement.innerText = `${Math.round(progress)}%`;
  }
};

const boxLoader = new GLTFLoader(firstLoadingManager).setPath('assets/boombox/');
const wallLoader = new GLTFLoader(firstLoadingManager).setPath('assets/wall/');
const campfireLoader = new GLTFLoader(firstLoadingManager).setPath('assets/bonfire/');
const leavesLoader = new GLTFLoader(firstLoadingManager).setPath('assets/leaves/');
const otherLeavesLoader = new GLTFLoader(secondLoadingManager).setPath('assets/leaves/');
const posterLoader = new GLTFLoader(secondLoadingManager).setPath('assets/poster/');
const palletLoader = new GLTFLoader(secondLoadingManager).setPath('assets/pallet/');

const tvLoader = new GLTFLoader(secondLoadingManager).setPath('assets/tv/');
const cardboardLoader = new GLTFLoader(secondLoadingManager).setPath('assets/box1/');
const cardboardLoader2 = new GLTFLoader(secondLoadingManager).setPath('assets/box2/');
const wallLoader2 = new GLTFLoader(secondLoadingManager).setPath('assets/wallSimple/');

Promise.all([
  new Promise((resolve, reject) => {
    boxLoader.load('scene.gltf', (gltf) => {
      boxMesh = gltf.scene;
      boxMesh.traverse((child) => {
        if (child.isMesh) {
          child.castShadow = true;
          child.receiveShadow = true;
        }
      });
      boxMesh.position.set(0.15, 0, -1);
      boxMesh.rotation.set(0 , - Math.PI / 8 , 0);
      scene.add(boxMesh);
      resolve();
    }, undefined, reject);
  }),
  new Promise((resolve, reject) => {
    wallLoader.load('scene.gltf', (gltf) => {
      wallMesh = gltf.scene;
      wallMesh.traverse((child) => {
        if (child.isMesh) {
          child.castShadow = false;
          child.receiveShadow = true;
        }
      });
      wallMesh.position.set(-3, -0.03, -2.5);
      wallMesh.rotation.set(0 , Math.PI , 0);
      wallMesh.scale.set(0.05, 0.05, 0.05);
      scene.add(wallMesh);
      resolve();
    }, undefined, reject);
  }),
  new Promise((resolve, reject) => {
    campfireLoader.load('scene.gltf', (gltf) => {
      campfireMesh = gltf.scene;
      campfireMesh.traverse((child) => {
        if (child.isMesh) {
          child.castShadow = true;
          child.receiveShadow = false;
        }
      });
      campfireMesh.position.set(4, 0, -1);
      scene.add(campfireMesh);
      resolve();
    }, undefined, reject);
  }),
  new Promise((resolve, reject) => {
    leavesLoader.load('scene.gltf', (gltf) => {
      leavesMesh = gltf.scene;
      leavesMesh.traverse((child) => {
        if (child.isMesh) {
          child.castShadow = true;
          child.receiveShadow = true;
        }
      });
      leavesMesh.position.set(-0.45, -0.1, -2.8);
      leavesMesh.rotation.set(0 , Math.PI * 1.2, 0);
      leavesMesh.scale.set(10, 10, 10);
      scene.add(leavesMesh);
      resolve();
    }, undefined, reject);
  }),
  new Promise((resolve, reject) => {
    otherLeavesLoader.load('scene.gltf', (gltf) => {
      otherLeavesMesh = gltf.scene;
      otherLeavesMesh.traverse((child) => {
        if (child.isMesh) {
          child.castShadow = true;
          child.receiveShadow = true;
        }
      });
      otherLeavesMesh.position.set(2.2, -0.1, -1.8);
      otherLeavesMesh.rotation.set(0 , Math.PI , 0);
      otherLeavesMesh.scale.set(12, 12, 12);
      scene.add(otherLeavesMesh);
      resolve();
    }, undefined, reject);
  }),
  new Promise((resolve, reject) => {
    posterLoader.load('scene.gltf', (gltf) => {
      posterMesh = gltf.scene;
      posterMesh.traverse((child) => {
        if (child.isMesh) {
          child.castShadow = true;
          child.receiveShadow = false;
          const textureLoader = new THREE.TextureLoader();
          const newTexture = textureLoader.load('assets/poster.png');
          child.material.map = newTexture;
          child.material.needsUpdate = true;
        }
      });
      posterMesh.position.set(-0.7, 0.7, -1.9);
      posterMesh.scale.set(0.01, 0.01, 0.01);
      posterMesh.rotation.set(0 , Math.PI , 0);
      scene.add(posterMesh);
      resolve();
    }, undefined, reject);
  }),
  new Promise((resolve, reject) => {
    palletLoader.load('scene.gltf', (gltf) => {
      palletMesh = gltf.scene;
      palletMesh.traverse((child) => {
        if (child.isMesh) {
          child.castShadow = true;
          child.receiveShadow = false;
        }
      });
      palletMesh.position.set(-4.5, 1.33, -1.87);
      palletMesh.rotation.set(Math.PI / 2.1 , Math.PI / 2 , 0);
      palletMesh.scale.set(0.025, 0.025, 0.025);
      scene.add(palletMesh);
      resolve();
    }, undefined, reject);
  }),
    ]).then(() => {
  document.getElementById('first-progress-container').style.display = 'none';
  return Promise.all([
  new Promise((resolve, reject) => {
    tvLoader.load('scene.gltf', (gltf) => {
    const originalTV = gltf.scene;

    const rotations = [
      [0, Math.PI / 0.67, 0], 
      [0, Math.PI / 0.73, 0], 
      [0, Math.PI / 0.79, 0],
      [0, Math.PI / 0.62, 0], 
      [0, Math.PI / 0.7, 0], 
      [0, Math.PI / 0.765, 0],
      [0, Math.PI / 0.85, 0], 
      [0, Math.PI / 0.65, 0], 
      [0, Math.PI / 0.74, 0], 
      [0, Math.PI / 0.8, 0],
      [0, Math.PI / 0.765, 0]
    ];

    for (let i = 0; i <= 10; i++) {
        const tvMesh = originalTV.clone();

        tvMesh.traverse((child) => {
            if (child.isMesh) {
                child.castShadow = true;
                child.receiveShadow = true;

                if (child.name === 'Object_7029') {
                    const video = document.createElement('video');
                    video.src = `assets/works/${i}.webm`;
                    video.loop = true;
                    video.muted = true;
                    video.playsInline = true;
                    video.pause(); // Ensure the video is paused
                    const videoTexture = new THREE.VideoTexture(video);
                    videoTexture.colorSpace = THREE.SRGBColorSpace;

                    videoTexture.center.set(0.5, 0.5);
                    videoTexture.rotation = Math.PI; // Rotate the texture by 180 degrees

                    videoTexture.needsUpdate = true;

                    child.material = new THREE.MeshBasicMaterial({
                        map: videoTexture,
                        toneMapped: false
                    });
                }
            }
        });

        tvMesh.position.set(...tvInfo[i].position);
        tvMesh.scale.set(0.1, 0.1, 0.1);
        tvMesh.rotation.set(...rotations[i]);
        tvMesh.userData.id = i;

        scene.add(tvMesh);

        tvMeshes.push(tvMesh);
    }

    [tvMesh0, tvMesh1, tvMesh2, tvMesh3, tvMesh4, tvMesh5, tvMesh6, tvMesh7, tvMesh8, tvMesh9, tvMesh10] = tvMeshes;
});
    resolve();
  }),

  new Promise((resolve, reject) => {
    cardboardLoader.load('scene.gltf', (gltf) => {
      cardboardMesh = gltf.scene;
      cardboardMesh.traverse((child) => {
        if (child.isMesh) {
          child.castShadow = false;
          child.receiveShadow = false;
        }
      });
      cardboardMesh.position.set(1.72, 0, 0.83);
      cardboardMesh.rotation.set(0, Math.PI / 0.65, 0);
      cardboardMesh.scale.set(0.102, 0.102, 0.102);
      scene.add(cardboardMesh);
      resolve();
    }, undefined, reject);
  }),
  new Promise((resolve, reject) => {
    cardboardLoader2.load('scene.gltf', (gltf) => {
      cardboardMesh2 = gltf.scene;
      cardboardMesh2.traverse((child) => {
        if (child.isMesh) {
          child.castShadow = false;
          child.receiveShadow = false;
        }
      });
      cardboardMesh2.position.set(1.19, 0, 2.17);
      cardboardMesh2.rotation.set(0, Math.PI / 0.71, 0);
      cardboardMesh2.scale.set(0.113, 0.113, 0.113);
      scene.add(cardboardMesh2);
      resolve();
    }, undefined, reject);
  }),

  new Promise((resolve, reject) => {
    wallLoader2.load('scene.gltf', (gltf) => {
      wallMesh2 = gltf.scene;
      wallMesh2.traverse((child) => {
        if (child.isMesh) {
          child.castShadow = false;
          child.receiveShadow = true;

          child.material.metalness = 0;
          child.material.roughness = 1;
        }
      });
      wallMesh2.position.set(2.2, -0.2, 1.5);
      wallMesh2.rotation.set(0, 4.305, 0);
      wallMesh2.scale.set(0.2, 0.2, 0.2);
      scene.add(wallMesh2);
      resolve();
    }, undefined, reject);
  }), 

    ]).then(() => {

  document.getElementById('second-progress-container').style.display = 'none';
}).catch((error) => {
  console.error('An error occurred while loading the models:', error);
});
}).catch((error) => {
  console.error('An error occurred while loading the models:', error);
});






const handleBoomboxClicked = () => {
  if (isBoomboxPlaying) {
    music.pause();

    const cassetteOutSoundClone = cassetteOutSound.cloneNode();
    cassetteOutSoundClone.volume = cassetteOutSound.volume;
    cassetteOutSoundClone.play();

    isBoomboxPlaying = false;
  } else {
    const cassetteSoundClone = cassetteSound.cloneNode();
    cassetteSoundClone.volume = cassetteSound.volume;
    cassetteSoundClone.play();

    const songTimes = [30,60,83,110,143,177,251,300,350,383,410,436,490,535,568,620,644,676,709,742,772,812,858,902,961,1012,1130,1250,1298,1439];
    const randomIndex = Math.floor(Math.random() * songTimes.length);
    music.currentTime = songTimes[randomIndex];
    music.play();

    isBoomboxPlaying = true;
  }
};

const handleCampfireClicked = () => {
  if (isCampfireBurning) {
    const fireEndSoundClone = fireEndSound.cloneNode();
    fireEndSoundClone.volume = fireEndSound.volume;
    fireEndSoundClone.play();

    fireSound.pause();
    fireSound.currentTime = 0;

    isCampfireBurning = false;
    campfireLight.visible = isCampfireBurning;
    firePlaneMesh.visible = isCampfireBurning;
  } else {
    const fireStartSoundClone = fireStartSound.cloneNode();
    fireStartSoundClone.volume = fireStartSound.volume;
    fireStartSoundClone.play();

    fireSound.play();

    isCampfireBurning = true;
    fireFactor = 0.5;

    campfireLight.visible = isCampfireBurning;
    firePlaneMesh.visible = isCampfireBurning;

    turnFireOn();
  }
};

const handleLeavesClicked = () => {
  if (!gsap.isTweening(leavesMesh.rotation)) {
    const leavesSoundClone = leavesSound.cloneNode();
    leavesSoundClone.volume = leavesSound.volume;
    leavesSoundClone.play();
    gsap.to(leavesMesh.rotation, {
      x: leavesMesh.rotation.x + 0.01,
      duration: 0.2,
      ease: "power2.inOut",
      yoyo: true,
      repeat: 1
    });
  }
};

const handleOtherLeavesClicked = () => {
  if (!gsap.isTweening(otherLeavesMesh.rotation)) {
    const leavesSoundClone = leavesSound.cloneNode();
    leavesSoundClone.volume = leavesSound.volume;
    leavesSoundClone.play();
    gsap.to(otherLeavesMesh.rotation, {
      x: otherLeavesMesh.rotation.x + 0.01,
      duration: 0.2,
      ease: "power2.inOut",
      yoyo: true,
      repeat: 1
    });
  }
};

const turnFireOn = () => {  
  fireFactor += 0.01;
  fireShaderMaterial.uniforms.fireFactor.value = fireFactor;

  if (fireFactor < 6) {
    requestAnimationFrame(turnFireOn);
  }
}

const handleTvClicked = (tvId) => {
  if (lockClicks) return;
  if (tvId !== 10) {
    lockClicks = true;
    tvClicked = true;
    lockCameraRotation = true;
    gsap.to(cameraDirection, {
      x: tvMeshes[tvId].position.x,
      y: tvMeshes[tvId].position.y + 0.1075,
      z: tvMeshes[tvId].position.z,
      duration: 1,
      ease: "power2.out",
      onUpdate: () => {
        camera.lookAt(cameraDirection);
      }
    });
    gsap.to(camera.position, {
      x: tvMeshes[tvId].position.x,
      y: tvMeshes[tvId].position.y + 0.1075,
      z: tvMeshes[tvId].position.z,
      duration: 1,
      ease: "power2.out",
      onUpdate: () => {
        camera.lookAt(cameraDirection);
      },
    });
    gsap.to(darknessContainer, {
          display: 'block',
          opacity: 1,
          duration: 0.5,
          ease: "power2.out",
          onComplete: () => {
            setTimeout(() => {
              lockCameraRotation = false;
            }, 3000);
            lockClicks = false;
          }
        });

      
    gsap.to(detailContainers[`detail${tvId}`], {
      opacity: 1,
      transform: 'translate(-50%, -50%)',
      duration: 0.7,
      delay: 0.1,
      ease: "power2.out",
      onStart: () => {
        detailContainers[`detail${tvId}`].style.display = 'flex';
      }
    });
  
    const videos = detailContainers[`detail${tvId}`].querySelectorAll('video');
    videos.forEach(video => {
      video.play();
    });
  }
  else {
    contactButton.click();
  }

  updateInterface();
};

let currentHoveredTV = null;

const tvRaycaster = () => {
  if (tvMeshes.length === 0 || lockClicks || lockCameraRotation) return;

  raycaster.setFromCamera(mouse, camera);
  const intersectsTVs = raycaster.intersectObjects(tvMeshes, true);

  let hoveredTV = null;

  if (intersectsTVs.length > 0) {
    hoveredTV = intersectsTVs[0].object;
    while (hoveredTV && hoveredTV.userData.id === undefined) {
      hoveredTV = hoveredTV.parent;
    }
  }
  else {
    tvHover.style.display = 'none';
    document.body.style.cursor = 'auto';
  }

  if (hoveredTV !== currentHoveredTV) {
    tvMeshes.forEach(tv => {
      tv.traverse(child => {
        if (child.isMesh && child.name === 'Object_7029' && child.material.map instanceof THREE.VideoTexture) {
          if (hoveredTV && hoveredTV === tv) {
            return;
          }
          child.material.map.image.pause();
          child.material.map.image.currentTime = 0.033; // Reset to the first frame
        }
      });
    });

    if (hoveredTV && !tvClicked && cameraTurned) {
      hoveredTV.traverse(child => {
        if (child.isMesh && child.name === 'Object_7029' && child.material.map instanceof THREE.VideoTexture) {
          child.material.map.image.play(); // Play the hovered TV's video
        }
      });

      tvHover.style.display = 'block';
      tvHover.style.left = `-100px`;
      tvHover.style.top = `-100px`;
      tvHover.textContent = tvInfo[hoveredTV.userData.id].title;
      document.body.style.cursor = 'none';
    } else {
      tvHover.style.display = 'none';
      document.body.style.cursor = 'auto';
    }

    currentHoveredTV = hoveredTV;
  }
  if (inContactSection) {
    tvHover.style.display = 'none';
    document.body.style.cursor = 'auto';
  }
};


const handleClick = (event) => {
  mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
  mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

  raycaster.setFromCamera(mouse, camera);

  const intersectsTVs = raycaster.intersectObjects(tvMeshes, true);
if (intersectsTVs.length > 0) {
    let clickedTV = intersectsTVs[0].object;
    while (clickedTV && clickedTV.userData.id === undefined) {
        clickedTV = clickedTV.parent;
    }

    if (clickedTV) {
        handleTvClicked(clickedTV.userData.id);
    }
}

  const intersectsBoombox = raycaster.intersectObject(boxMesh, true);
  const intersectsCampfire = raycaster.intersectObject(campfireMesh, true);
  const intersectsLeaves = raycaster.intersectObject(leavesMesh, true);
  const intersectsOtherLeaves = raycaster.intersectObject(otherLeavesMesh, true);
  const intersectsWall = raycaster.intersectObject(wallMesh, true);
  const intersectsPallet = raycaster.intersectObject(palletMesh, true);
  const intersectsGround = raycaster.intersectObject(groundMesh, true);
  const intersectsPoster = raycaster.intersectObject(posterMesh, true);

  if (intersectsBoombox.length > 0) {
    handleBoomboxClicked();
  }
  if (intersectsCampfire.length > 0) {
    handleCampfireClicked();
  }
  if (intersectsLeaves.length > 0 && intersectsBoombox.length === 0) {
    handleLeavesClicked();
  }
  if (intersectsOtherLeaves.length > 0 && intersectsBoombox.length === 0) {
    handleOtherLeavesClicked();
  }
  if (intersectsWall.length > 0 && 
    intersectsBoombox.length === 0 && 
    intersectsCampfire.length === 0 && 
    intersectsLeaves.length === 0 && 
    intersectsOtherLeaves.length === 0 &&
    intersectsPallet.length === 0 &&
    intersectsPoster.length === 0
  ) { 
    const wallSoundClone = wallSound.cloneNode();
    wallSoundClone.volume = wallSound.volume;
    wallSoundClone.play();
  }
  if (intersectsPallet.length > 0 && intersectsCampfire.length === 0) {
    const woodSoundClone = woodSound.cloneNode();
    woodSoundClone.volume = woodSound.volume;
    woodSoundClone.play();
  }
  if (intersectsGround.length > 0 &&
    intersectsBoombox.length === 0 && 
    intersectsCampfire.length === 0 && 
    intersectsLeaves.length === 0 && 
    intersectsOtherLeaves.length === 0 &&
    intersectsPallet.length === 0 &&
    intersectsWall.length === 0
  ) {
    const groundSoundClone = groundSound.cloneNode();
    groundSoundClone.volume = groundSound.volume;
    groundSoundClone.play();
  }
  if (intersectsPoster.length > 0) {
    const paperSoundClone = paperSound.cloneNode();
    paperSoundClone.volume = paperSound.volume;
    paperSoundClone.play();
    aboutMeButton.click();
  }
};

window.addEventListener('click', handleClick);


const fireShaderMaterial = new THREE.ShaderMaterial({
  transparent: true,
  uniforms: {
    iTime: { value: 0.0 },
    iResolution: { value: new THREE.Vector2(window.innerWidth, window.innerHeight) },
    fireFactor: { value: 6.0 } 
  },
  vertexShader: `
    varying vec2 vUv;

    void main() {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `,
  fragmentShader: `
    varying vec2 vUv;

    uniform float iTime;
    uniform vec2 iResolution;
    uniform float fireFactor;

    vec2 hash( vec2 p ) {
      p = vec2( dot(p,vec2(127.1,311.7)),
                dot(p,vec2(269.5,183.3)) );
      return -1.0 + 2.0 * fract(sin(p) * 43758.5453123);
    }

    float noise( in vec2 p ) {
      const float K1 = 0.366025404; // (sqrt(3)-1)/2;
      const float K2 = 0.211324865; // (3-sqrt(3))/6;
      
      vec2 i = floor( p + (p.x + p.y) * K1 );
      
      vec2 a = p - i + (i.x + i.y) * K2;
      vec2 o = (a.x > a.y) ? vec2(1.0, 0.0) : vec2(0.0, 1.0);
      vec2 b = a - o + K2;
      vec2 c = a - 1.0 + 2.0 * K2;
      
      vec3 h = max( 0.5 - vec3(dot(a, a), dot(b, b), dot(c, c)), 0.0 );
      
      vec3 n = h * h * h * h * vec3( dot(a, hash(i + 0.0)), dot(b, hash(i + o)), dot(c, hash(i + 1.0)));
      
      return dot( n, vec3(70.0) );
    }

    float fbm(vec2 uv) {
      float f;
      mat2 m = mat2(1.6, 1.2, -1.2, 1.6);
      f  = 0.5000 * noise(uv); uv = m * uv;
      f += 0.2500 * noise(uv); uv = m * uv;
      f += 0.1250 * noise(uv); uv = m * uv;
      f += 0.0625 * noise(uv); uv = m * uv;
      f = 0.5 + 0.5 * f;
      return f;
    }

    void mainImage(out vec4 fragColor, in vec2 fragCoord) {
    
      vec2 uv = fragCoord.xy / iResolution.xy;
      vec2 q = uv;
      q.x *= 1.0;
      q.y *= 1.0;
      float strength = floor(q.x + fireFactor);
      float T3 = max(3.0, 1.25 * strength) * iTime;
      q.x = mod(q.x, 1.0) - 0.5;
      q.y -= 0.15;
      float n = fbm(strength * q - vec2(0, T3));
      float c = 1.0 - 16.0 * pow(max(0.0, length(q * vec2(1.8 + q.y * 1.5, 0.75)) - n * max(0.0, q.y + 0.25)), 1.2);
      float c1 = n * c * (1.5 - pow(2.50 * uv.y, 4.0));
      c1 = clamp(c1, 0.0, 1.0);

      if (uv.y > 0.43) discard;
      vec3 col = vec3(1.5 * c1, 1.5 * c1 * c1 * c1, c1 * c1 * c1 * c1 * c1 * c1);
      
      float alpha = c1;

      fragColor = vec4(col, alpha);
    }

    void main() {
      mainImage(gl_FragColor, vUv * iResolution.xy);
    }
  `
});

let fireFactor = fireShaderMaterial.uniforms.fireFactor.value;
let firePlaneGeometry = new THREE.PlaneGeometry(1.8 * fireFactor / 6, 2 * fireFactor / 6);

const updateFirePlaneGeometry = () => {
  scene.remove(firePlaneMesh);
  firePlaneGeometry = new THREE.PlaneGeometry(1.8 * fireFactor / 6, 2 * fireFactor / 6);
  firePlaneGeometry.translate(0, fireFactor / 6, 0); // Adjust the anchor point
  firePlaneMesh.geometry.dispose();
  firePlaneMesh.geometry = firePlaneGeometry;
  scene.add(firePlaneMesh);
};

firePlaneGeometry.translate(0, fireFactor / 6, 0); // Adjust the anchor point
const firePlaneMesh = new THREE.Mesh(firePlaneGeometry, fireShaderMaterial);

firePlaneMesh.position.set(-1.35, 0, -0.5);
firePlaneMesh.lookAt(camera.position);

const campfireLight = new THREE.PointLight(0xFF4500, 1, 50); 
campfireLight.position.set(-1.45, 0.35, -0.6);
scene.add(campfireLight);
campfireLight.castShadow = true;

const flickerLight = () => {
  const randomIntensity = THREE.MathUtils.lerp(0.5, 3.5, Math.random()) * (fireFactor / 6);
  const randomColor = new THREE.Color(`hsl(${Math.random() * 10 + 30}, 100%, 50%)`);

  gsap.to(campfireLight, {
    intensity: randomIntensity,
    duration: 0.65,
    ease: "power2.out"
  });

  gsap.to(campfireLight.color, {
    r: randomColor.r,
    g: randomColor.g,
    b: randomColor.b,
    duration: 0.5,
    ease: "power2.out"
  });

  setTimeout(flickerLight, Math.random() * 50 + 50);
}

flickerLight();
scene.add(firePlaneMesh);

window.addEventListener('resize', () => {
  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();
  renderer.setSize(window.innerWidth, window.innerHeight);
});

aboutMeButton.addEventListener('click', (event) => {
  if (lockClicks) return;
  lockClicks = true;
  event.stopPropagation();

  lockCameraRotation = true;
  inAboutSection = true;

  gsap.to(camera.position, { x: -0.69, y: 1.2, z: 0.5, duration: 0.95, ease: "power1.out" });
  gsap.to(cameraDirection, { 
    x: -0.69, 
    y: 1.2, 
    z: -2.5, 
    duration: 0.95, 
    ease: "power1.out", 
    onUpdate: () => {
      camera.lookAt(cameraDirection);
    },
    onComplete: () => {
      lockClicks = false;
    }
  });
  gsap.to(cameraDirection, { 
    x: -0.69, 
    y: 1.2, 
    z: -2.5, 
    duration: 0.65,
    delay: 0.95,
    onUpdate: () => {
      camera.lookAt(cameraDirection);
    },
    onComplete: () => {
      cameraDirection.x = -0.69;
      cameraDirection.y = 1.2;
      cameraDirection.z = -2.5;
      camera.lookAt(cameraDirection);
    }
  });
  updateInterface();
});

aboutCloseButton.addEventListener('click', (event) => {
  if (lockClicks || !inAboutSection) return;
  console.log('Closing about section');
  lockClicks = true;
  event.stopPropagation();

  inAboutSection = false;
  gsap.to(camera.position, { x: 0.4, y: 0.7, z: 1.2, duration: 0.95, ease: "power1.out" });
  gsap.to(cameraDirection, { 
    x: -0.265, 
    y: 0.5, 
    z: -0.3, 
    duration: 0.95, 
    ease: "power1.out",
    onUpdate: () => {
      camera.lookAt(cameraDirection);
    },
    onComplete: () => {
      cameraDirection.x = -0.265;
      cameraDirection.y = 0.5;
      cameraDirection.z = -0.3;
      camera.lookAt(cameraDirection);
      lockClicks = false;
      lockCameraRotation = false;
    }
  });
  updateInterface();
});

contactButton.addEventListener('click', (event) => {
  if (lockClicks) return;
  event.stopPropagation();

  inContactSection = true;
  updateInterface();
});

contactCloseButton.addEventListener('click', (event) => {
  if (lockClicks || !inContactSection) return;
  event.stopPropagation();
  console.log('Closing contact section');

  inContactSection = false;
  updateInterface();
});

cameraTurnButton.addEventListener('click', (event) => {
  if (lockClicks) return;
  lockClicks = true;
  event.stopPropagation();

  const current = root.getAttribute('data-theme');
  changeLight(current, !cameraTurned, 0, 0.65);

  lockCameraRotation = true;
  if (cameraTurned) {
    gsap.to(camera.position, { x: 0.6, y: 0.9, z: 1.2, duration: 0.65, ease: "power1.in", onUpdate: () => camera.lookAt(cameraDirection), onComplete: () => {
      gsap.to(camera.position, { x: 0.4, y: 0.7, z: 1.2, duration: 0.65, ease: "power1.out" });
    }});
    gsap.to(cameraDirection, { x: 0.4, y: 0, z: 1.2, duration: 0.65, ease: "power1.in", onUpdate: () => camera.lookAt(cameraDirection), onComplete: () => {
      gsap.to(cameraDirection, { x: -0.265, y: 0.5, z: -0.3, duration: 0.65, ease: "power1.out", onUpdate: () => camera.lookAt(cameraDirection), onComplete: () => {
          lockCameraRotation = false;
      }});
    }});
    gsap.to(darknessContainer, {
      display: 'block',
      opacity: 1,
      duration: 0.65,
      ease: "power1.out",
      onComplete: () => {
        gsap.to(darknessContainer, {
          opacity: 0,
          duration: 0.65,
          ease: "power1.in",
          onComplete: () => {
            darknessContainer.style.display = 'none';
            lockClicks = false;
          }
        });
      }
    });
  } else {
    gsap.to(camera.position, { x: 0.6, y: 0.9, z: 1.2, duration: 0.65, ease: "power1.in", onUpdate: () => camera.lookAt(cameraDirection), onComplete: () => {
      gsap.to(camera.position, { x: 0.6, y: 0.2, z: 1.2, duration: 0.65, ease: "power1.out" });
    }});
    gsap.to(cameraDirection, { x: 0.6, y: 0, z: 1.2, duration: 0.65, ease: "power1.in", onUpdate: () => camera.lookAt(cameraDirection), onComplete: () => {
      gsap.to(cameraDirection, { x: 1.665, y: 0.5, z: 1.6, duration: 0.65, ease: "power1.out", onUpdate: () => camera.lookAt(cameraDirection), onComplete: () => {
          lockCameraRotation = false;
      }});
    }});
    gsap.to(darknessContainer, {
      display: 'block',
      opacity: 1,
      duration: 0.65,
      ease: "power1.in",
      onComplete: () => {
        gsap.to(darknessContainer, {
          opacity: 0,
          duration: 0.65,
          ease: "power1.out",
          onComplete: () => {
            darknessContainer.style.display = 'none';
            lockClicks = false;
          }
        });
      }
    });
  }
  cameraTurned = !cameraTurned;
  updateInterface();
});

lightModeButton.addEventListener('click', (event) => {
  if (lockClicks) return;
  event.stopPropagation();
  const current = root.getAttribute('data-theme');
  const next = current === 'dark' ? 'light' : 'dark';
  root.setAttribute('data-theme', next);
  localStorage.setItem('theme', next);

  changeLight(next, cameraTurned, 0.7, 0);
});

backButton.addEventListener('click', (event) => {
  if (lockClicks) return;
  event.stopPropagation();

  if (cameraTurned && !tvClicked) {
      if (inContactSection) {
        contactCloseButton.click();
      }
      setTimeout(() => {
        cameraTurnButton.click();
      }, 300);
      return;
  }

  if (tvClicked) {
      gsap.to(camera.position, { 
        x: 0.6, 
        y: 0.2, 
        z: 1.2, 
        duration: 0.65, 
        ease: "power1.out", 
      });

    gsap.to(cameraDirection, { x: 1.665, y: 0.5, z: 1.6, duration: 0.65, ease: "power1.out", onUpdate: () => camera.lookAt(cameraDirection), onComplete: () => {
          lockCameraRotation = false;
    }});
        gsap.to(darknessContainer, {
          opacity: 0,
          duration: 0.65,
          ease: "power1.out",
          onComplete: () => {
            darknessContainer.style.display = 'none';
            lockClicks = false;
          }
        });
    tvClicked = false;
    updateInterface();
  }
});

if (saved) {
  root.setAttribute('data-theme', saved);
} else {
  root.setAttribute('data-theme', 'dark');
}

const updateSoundVolumes = () => {
  ambient.volume = 0.12 * generalSound;
  fireSound.volume = 0.2 * generalSound;
  music.volume = 0.3 * generalSound;
  cassetteOutSound.volume = 0.3 * generalSound;
  cassetteSound.volume = 0.3 * generalSound;
  fireEndSound.volume = 0.3 * generalSound;
  fireStartSound.volume = 0.3 * generalSound;
  leavesSound.volume = 0.3 * generalSound;
  groundSound.volume = 0.3 * generalSound;
  wallSound.volume = 0.4 * generalSound;
  woodSound.volume = 0.4 * generalSound;
  paperSound.volume = 0.3 * generalSound;
};

soundToggleButton.addEventListener('click', (event) => {
  generalSound = generalSound === 1 ? 0 : 1;
  if (generalSound === 1) {
    document.getElementById('icon-mute').style.display = 'none';
    document.getElementById('icon-sound').style.display = 'block';
  } else {
    document.getElementById('icon-mute').style.display = 'block';
    document.getElementById('icon-sound').style.display = 'none';
  }
  updateSoundVolumes();
  console.log(`General sound ${generalSound === 1 ? 'on' : 'off'}`);
});

contactContainer.addEventListener('click', (event) => {
  event.stopPropagation();
});

aboutMeContainer.addEventListener('click', (event) => {
  event.stopPropagation();
});

emailLink.addEventListener('click', (event) => {
  const email = 'fedir.yatsenko@gmail.com';
  navigator.clipboard.writeText(email).then(() => {
    console.log('Email copied to clipboard:', email);
    popupAnimate();
  }).catch((err) => {
    console.error('Failed to copy email:', err);
  });
});

phoneLink.addEventListener('click', (event) => {
  const phoneNumber = '+32478199977';
  navigator.clipboard.writeText(phoneNumber).then(() => {
    console.log('Phone number copied to clipboard:', phoneNumber);
    popupAnimate();
  }).catch((err) => {
    console.error('Failed to copy phone number:', err);
  });
});

const popupAnimate = () => {
  gsap.fromTo('.popup', 
    { opacity: 0, bottom: '-25%' }, 
    { 
      opacity: 1, 
      bottom: '-20%', 
      duration: 0.5, 
      onComplete: () => {
        gsap.to('.popup', { opacity: 0, duration: 0.5 });
      }
    }
  );
}

detailCloseButtons.forEach(button => {
  button.addEventListener('click', (event) => {
    if (lockClicks || !tvClicked) return;
    event.stopPropagation();

    backButton.click();

  });
});

darknessContainer.addEventListener('click', (event) => {
  event.stopPropagation();
  if (tvClicked) {
    backButton.click();
  }
});

function animate() {
  updateSoundVolumes();

  requestAnimationFrame(animate);

  if (isCampfireBurning) {
    fireShaderMaterial.uniforms.iTime.value += 0.003;
  }

  if (generalSound === 1) {
    fireSound.volume = THREE.MathUtils.lerp(0.1, 0.5, fireFactor / 6);
  }

  updateFirePlaneGeometry();

  if (!lockCameraRotation) {
    updateCameraRotation();
  }

  if (cameraTurned && !tvClicked) {
    tvRaycaster();
  }
  else {
    tvHover.style.display = 'none';
    document.body.style.cursor = 'auto';
  }

  renderer.render(scene, camera);


}

animate();





